import { MaskedReveal } from "@/components/MaskedReveal";
import { WaitlistForm } from "@/components/WaitlistForm";

export const WaitlistSection = () => {
  return (
    <section id="waitlist" className="px-6 py-24 sm:px-10 sm:py-32 lg:py-40">
      <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">
            Register interest
          </span>
          <MaskedReveal
            as="h2"
            className="mt-6 font-display font-light tracking-tight text-espresso"
            lineClassName="text-5xl leading-[0.98] sm:text-6xl"
            lines={["Opening soon in", "Horizon Hills, Johor."]}
          />
          <p className="mt-8 max-w-md font-body text-lg font-light leading-relaxed text-stone">
            We're putting the finishing touches on the room. Leave your details and
            we'll be in touch with founding-member details, previews and first
            access before the doors open.
          </p>
          <div className="mt-10 border-t border-espresso/10 pt-8">
            <span className="block font-display text-3xl font-light leading-tight text-oak sm:text-4xl">
              Register Your Interest!
            </span>
            <span className="mt-3 block max-w-md font-body text-sm font-light text-stone">
              And stand to receive a surprise from us when we launch!
            </span>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <WaitlistForm tone="light" />
        </div>
      </div>
    </section>
  );
};

export default WaitlistSection;
